<div class="viewer-header d-flex align-items-center justify-content-between px-4">
    <div class="fw-bold fs-5 d-flex flex-column min-w-0">
        <span class="text-truncate">{{ activeItem()?.title ?? title() }}</span>
        <span class="fs-6 text-secondary fw-normal" *ngIf="items().length > 0">
            {{ activeIndex() + 1 }} / {{ items().length }}
            @if (isPdf()) {
                <span class="ms-2 badge border border-secondary text-secondary">PDF</span>
            }
        </span>
    </div>

    <div class="d-flex align-items-center gap-3 flex-shrink-0">
        @if (!appSettings.isMobile()) {
            <ng-content select="[viewer-actions]"></ng-content>
        }

        @if (!isPdf()) {
            <button (click)="rotateImage(-90); $event.stopPropagation()" class="viewer-btn-icon text-info" title="Rotar Izquierda">
                <i class="fa fa-undo"></i>
            </button>
            <button (click)="rotateImage(90); $event.stopPropagation()" class="viewer-btn-icon text-info" title="Rotar Derecha">
                <i class="fa fa-redo"></i>
            </button>
        }

        @if (allowDelete() && activeItem()) {
        <button (click)="onDelete.emit(activeItem()!.id)" class="viewer-btn-icon text-danger" title="Eliminar">
            <i class="fa fa-trash"></i>
        </button>
        }

        <div style="width: 1px; height: 24px; background: rgba(255,255,255,0.1);"></div>

        <button (click)="close.emit()" class="viewer-btn-icon" title="Cerrar">
            <i class="fa fa-times fa-lg"></i>
        </button>
    </div>
</div>

<div class="flex-grow-1 position-relative overflow-hidden d-flex">
    <div class="flex-grow-1 position-relative overflow-hidden bg-black d-flex align-items-center justify-content-center user-select-none w-100 h-100 viewer-stage"
        (mousedown)="startDrag($event)"
        (wheel)="onWheel($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd($event)"
        (touchcancel)="onTouchEnd($event)"
        [style.cursor]="isPdf() ? 'default' : (isDragging() ? 'grabbing' : 'grab')">

        @if (!isPdf()) {
            <div class="position-absolute top-0 start-0 w-100 h-100 pe-none grid-bg"></div>
        }

        @if (activeSrc(); as src) {
            @if (isPdf()) {
                <iframe
                    class="viewer-pdf-frame"
                    [src]="src | safeUrl"
                    title="Vista previa PDF">
                </iframe>
            } @else {
                <img #imageEl [src]="src"
                    class="mw-100 mh-100 w-auto h-auto object-fit-contain pe-none shadow-lg"
                    [style.transform]="transformStyle()" draggable="false"
                    style="transform-origin: center; transition: transform 0.075s; will-change: transform;">
            }
        } @else {
            <div class="text-secondary d-flex flex-column align-items-center gap-2">
                <i class="fa fa-image fa-3x"></i>
                <span>No hay documento para mostrar</span>
            </div>
        }

        @if (!isPdf() && !appSettings.isMobile()) {
            <div class="zoom-controls">
                <button (click)="zoomOut(); $event.stopPropagation()" class="btn btn-sm text-white rounded-circle">
                    <i class="fa fa-minus"></i>
                </button>
                <span class="text-center font-monospace" style="width: 48px; font-size: 0.85rem;">
                    {{ (zoomLevel() * 100) | number:'1.0-0' }}%
                </span>
                <button (click)="zoomIn(); $event.stopPropagation()" class="btn btn-sm text-white rounded-circle">
                    <i class="fa fa-plus"></i>
                </button>
                <div style="width: 1px; height: 16px; background: rgba(255,255,255,0.2);" class="mx-1"></div>
                <button (click)="reset(); $event.stopPropagation()" class="btn btn-sm text-white rounded-circle" title="Resetear vista">
                    <i class="fa fa-expand"></i>
                </button>
            </div>
        }

        @if (items().length > 1 && !appSettings.isMobile()) {
        <button (click)="prev(); $event.stopPropagation()" [disabled]="activeIndex() === 0"
            class="position-absolute top-50 start-0 translate-middle-y ms-4 nav-arrow" style="z-index: 30;">
            <i class="fa fa-chevron-left fa-lg"></i>
        </button>

        <button (click)="next(); $event.stopPropagation()" [disabled]="activeIndex() === items().length - 1"
            class="position-absolute top-50 end-0 translate-middle-y me-4 nav-arrow" style="z-index: 30;">
            <i class="fa fa-chevron-right fa-lg"></i>
        </button>
        }
    </div>

    <ng-content select="[sidebar]"></ng-content>
</div>

@if (items().length > 1) {
<div class="thumbnail-footer">
    <div class="d-flex gap-2 overflow-x-auto p-2 mw-100 custom-scrollbar" style="scroll-snap-type: x mandatory;">
        @for (item of items(); track item.id) {
        <div (click)="onSelect.emit(item.id)" class="thumbnail-item bg-dark"
            [class.active]="item.id === activeId()" style="scroll-snap-align: center;">
            @if (isPdfItem(item)) {
                <div class="w-100 h-100 d-flex align-items-center justify-content-center text-danger">
                    <i class="fas fa-file-pdf fa-2x"></i>
                </div>
            } @else {
                <img [src]="item.imageUrl ?? 'assets/img/placeholder.png'" class="w-100 h-100" style="object-fit: cover;">
            }
        </div>
        }
    </div>
</div>
}

@if (appSettings.isMobile()) {
    <app-mobile-footer [visible]="true" [dark]="true" [embedded]="true">
        <ng-content select="[viewer-actions]"></ng-content>
    </app-mobile-footer>
}
